import type { IIconProps } from "@fluentui/react/lib/Icon";
import { getRTL, memoizeFunction } from "@fluentui/react/lib/Utilities";

const cachedIconProps = memoizeFunction(
  (
    iconName: string,
    iconColor?: string,
    hideIcon?: boolean,
    flip?: boolean,
    disabled?: boolean
  ): IIconProps => {
    // We need to set the color and fill attribute because some teams rely on it for their icon coloring
    return {
      iconName,
      ...((iconColor || hideIcon || flip || disabled) && {
        styles: {
          root: {
            ...(iconColor && { color: iconColor, fill: iconColor }),
            ...(hideIcon && { visibility: "hidden" }),
            ...(flip && {
              "-webkit-transform": "scaleX(-1)",
              transform: "scaleX(-1)",
            }),
            ...(disabled && { opacity: 0.4 }),
          },
        },
      }),
    };
  }
);

export const iconNameToIconProps = (
  iconName?: string,
  iconColor?: string,
  hideIcon?: boolean,
  flipInRtl?: boolean,
  disabled?: boolean,
  shouldFlipIcon?: boolean
): IIconProps | undefined => {
  const isRTL = getRTL();
  return iconName
    ? cachedIconProps(
        iconName,
        iconColor,
        hideIcon,
        (flipInRtl && isRTL) || shouldFlipIcon,
        disabled
      )
    : undefined;
};
